import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Keys } from "../utils/keys";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

function ViviaKeys() {
  const { t } = useTranslation();
  const scrollContainerRef = useRef<any>(null);
  const keys = Keys();
  const handleMouseDown = (e: React.MouseEvent) => {
    if (!scrollContainerRef.current) return;
    const startX = e.clientX;
    const scrollLeft = scrollContainerRef.current.scrollLeft;

    const handleMouseMove = (moveEvent: MouseEvent) => {
      const distance = startX - moveEvent.clientX;
      if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollLeft = scrollLeft + distance;
      }
    };
    const handleMouseUp = () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  return (
    <Grid
      container
      sx={{
        justifyContent: "center",
        alignItems: "center",
        gap: 5,

        background:
          "radial-gradient(39.87% 39.87% at 50% 50%, #0C3247 0%, #081525 100%)",
        pt: 2,
        pb: 3,
        maxWidth: "100vw",
        overflow: "hidden",
      }}
    >
      <Grid>
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: 900,
            fontSize: "28px",
            lineHeight: "52px",
            letterSpacing: "10%",
            textAlign: "center",
            verticalAlign: "middle",
            color: "#FFF",
          }}
        >
          {t("Key features")}
        </Typography>
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: 900,
            fontSize: { sx: "38px", lg: "39px" },
            lineHeight: "52px",
            letterSpacing: "10%",
            textAlign: "center",
            verticalAlign: "middle",
            color: "#FFF",
          }}
        >
          {t("driving the future of urban mobility")}
        </Typography>
      </Grid>

      <Box
        ref={scrollContainerRef}
        onMouseDown={handleMouseDown} // Enable mouse drag to scroll
        sx={{
          display: "flex",
          overflowX: { xs: "auto", lg: "visible" },
          justifyContent: "center",
          flexWrap: { xs: "none", md: "wrap" },
          scrollBehavior: { xs: "smooth", lg: "none" },
          gap: 2,
          py: 2,
          px: 1,
          "&::-webkit-scrollbar": { display: "none" }, // Hide scrollbar on Chrome/Safari
          "-ms-overflow-style": "none", // Hide scrollbar on IE/Edge
          "scrollbar-width": "none", // Hide scrollbar on Firefox
        }}
      >
        {keys.map((key, index) => (
          <Box
            // size={{ xs: 8, sm: 8, md: 3, lg: 3 }}
            key={index}
            sx={{
              border: "2px solid",
              borderImageSource:
                "radial-gradient(50% 875.74% at 50% 50%, #33BBA4 0%, #1F8FCE 100%)",
              borderImageSlice: 1,
              backdropFilter: "blur(23.4px)",
              alignItems: "center",
              justifyContent: "center",
              p: 3,

              display: "flex",
              flexDirection: "column",
              gap: 2,
              // height: 300,
              transition: "transform 0.3s ease-in-out",
              "&:hover": {
                transform: "scale(1.05)",
              },
              cursor: "pointer",
              width: { xs: "80%", sm: "50%", md: "40%", lg: "20%" }, // Control item width
              flexShrink: { xs: 0, lg: "initial" },
              borderRadius: 2,
              boxShadow: 2,
              userSelect: "none",
            }}
          >
            <img
              src={key.image}
              alt="AI"
              style={{
                maxWidth: "75%",
                height: "auto",
                transition: "transform 0.3s ease",
              }}
            />
            <Typography
              sx={{
                fontFamily: "Titillium Web",
                fontWeight: 700,
                fontSize: "20px",
                lineHeight: "100%",
                letterSpacing: "7%",
                textAlign: "center",
                color: "#FFF",
              }}
            >
              {key.title}
            </Typography>
            <Typography
              sx={{
                fontFamily: "Roboto",
                fontWeight: 500,
                fontSize: "18px",
                lineHeight: "23px",
                letterSpacing: "6%",
                textAlign: "justify",
                maxWidth: { xs: 270, lg: 400 },
                color: "#FFF",
              }}
            >
              {key.text}
            </Typography>
          </Box>
        ))}
      </Box>
    </Grid>
  );
}

export default ViviaKeys;
